<div class="d-flex flex-center current-place-name">
    @if (currentPlaceName) {
        <span class="ml-2"> {{ currentPlaceName }} </span>
    }
</div>